import PropTypes from 'prop-types';
// @mui
import { Grid } from '@mui/material';
import ShopProductCard from './ProductCard';
import GroupDeviceCard from './GroupDeviceCard';

// ----------------------------------------------------------------------

ProductList.propTypes = {
    products: PropTypes.array.isRequired,
};

export default function ProductList({
    action,
    url,
    isGroup = false,
    products,
    functDelete,
    setData,
    functEdit,
    screenPermissions,
    ...other
}) {
    return (
        <Grid container spacing={3} {...other}>
            {products.map((product) => (
                <Grid key={product.id} item xs={6} sm={4} md={3} lg={2.4} xl={2.4}>
                    {isGroup ? (
                        <GroupDeviceCard
                            url={url}
                            functDelete={functDelete}
                            functEdit={functEdit}
                            product={product}
                            action={action}
                            setData={setData}
                            screenPermissions={screenPermissions}
                        />
                    ) : (
                        <ShopProductCard
                            functDelete={functDelete}
                            functEdit={functEdit}
                            product={product}
                            setData={setData}
                            screenPermissions={screenPermissions}
                        />
                    )}
                </Grid>
            ))}
        </Grid>
    );
}
